/* eslint-disable import/prefer-default-export */
import { ref } from 'vue';

import { useGlobalStore } from '@/stores/globalStore';

const toasts = ref([]);

export function useToast() {
  const addToast = (toast) => {
    const globalStore = useGlobalStore();
    if (globalStore.getEmbeddedButtonOnlyIframeMode) return;
    toasts.value.push({
      id: Date.now(),
      ...toast,
    });
  };

  const removeToast = (id) => {
    toasts.value = toasts.value.filter((toast) => toast.id !== id);
  };

  return { toasts, addToast, removeToast };
}
